module.exports = __webpack_public_path__ + "static/img/irole.0d81d00.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/bn/irole.png
// module id = J/FR
// module chunks = 7